import type { InventoryMovementMode } from '../../hooks/useInventoryMovementMode';
import SegmentedControl from '../ui/SegmentedControl';

interface InventoryMovementModeToggleProps {
  mode: InventoryMovementMode;
  onModeChange: (mode: InventoryMovementMode) => void;
}

const MODE_OPTIONS: { value: InventoryMovementMode; label: string }[] = [
  { value: 'sales', label: 'Sales' },
  { value: 'consumed', label: 'Consumed' },
];

/** Sales / Consumed switch for the control-centre inventory header. */
export default function InventoryMovementModeToggle({
  mode,
  onModeChange,
}: InventoryMovementModeToggleProps) {
  return (
    <SegmentedControl
      options={MODE_OPTIONS}
      value={mode}
      onChange={onModeChange}
      ariaLabel="Stock movement view"
      className="w-[180px] shrink-0"
    />
  );
}
